/** 
 * 按钮
 * @props btnTxt {String|Number} - 按钮文本
 */

 import nfPage from './nfPage.vue'

 export default nfPage